import React from "react";

export default function CoverColumn(props: any) {
  return (
    <div className="first-column">
      <div className="cover-container">
        <img className="cover-picture" src={props.bookInfo.CoverImageURL} alt={props.bookInfo.title + " cover"} />
      </div>
    </div>
  );
}
